import { useContext } from 'react'

import RecipeIngredientsContentContext from '@contexts/recipeIngredientsContent'

const useIsInRecipeIngredientsContent = (): boolean =>
  useContext(RecipeIngredientsContentContext)

export default useIsInRecipeIngredientsContent
